/**
 * Labeled form input with error state.
 * @param {{
 *   id: string,
 *   label: string,
 *   error?: string,
 *   hint?: string,
 *   ...props
 * }} props
 */
export function Input({ id, label, error, hint, className = '', ...props }) {
  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium text-text-primary">
        {label}
      </label>
      {hint && (
        <p className="mt-1 text-xs text-text-muted" id={`${id}-hint`}>
          {hint}
        </p>
      )}
      <input
        id={id}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={
          error ? `${id}-error` : hint ? `${id}-hint` : undefined
        }
        className={`mt-1 block w-full rounded-md border bg-surface px-3 py-2 text-sm text-text-primary shadow-sm transition-colors placeholder:text-text-muted focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 ${
          error ? 'border-error' : 'border-border'
        }`}
        {...props}
      />
      {error && (
        <p id={`${id}-error`} role="alert" className="mt-1 text-xs text-error">
          {error}
        </p>
      )}
    </div>
  );
}